import React, {useEffect} from 'react';
import { useQuery } from '@tanstack/react-query';
import AppointmentListService from "./Services/AppointmentListService"; // Adjust path if needed
import moment from 'moment/moment';
import { useMemo } from 'react';
import { useState } from 'react';
import handlePrintPrescription from "./handlePrintPrescription";
import handlePrintInvoice from './handlePrintInvoice';
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation,Grid } from 'swiper/modules';
import "swiper/css/grid";
import { Link } from 'react-router-dom';
import { serverConfig } from '../ApiSearchPath/ApiSearchPath';

const Dashboard =() => {
  const patientId = +localStorage.getItem('userId');
const type = "PATIENT";
const getNextSevenDays = () => {
  const days = [];
  const today = new Date();

  for (let i = 0; i < 7; i++) {
    const d = new Date(today);
    d.setDate(today.getDate() + i);

    days.push({
      fullDate: d,
      date: d.getDate(),
      day: d.toLocaleDateString("en-US", { weekday: "short" }),
    });
  }

  return days;
};
const [calendarDates] = useState(getNextSevenDays());
const todayDate= new Date();
const [selectedDate, setSelectedDate] = useState(
  calendarDates[0].fullDate.toDateString()
);
     useEffect(() => {
            const scriptUrls = [
              "assets/js/jquery-3.7.1.min.js",
              "assets/js/bootstrap.bundle.min.js",
              "assets/plugins/theia-sticky-sidebar/ResizeSensor.js",
              "assets/plugins/theia-sticky-sidebar/theia-sticky-sidebar.js",
              "assets/plugins/select2/js/select2.min.js",
              "assets/js/owl.carousel.min.js",
              "assets/plugins/apex/apexcharts.min.js",
              "assets/plugins/apex/chart-data.js",
              "assets/js/moment.min.js",
              "assets/plugins/daterangepicker/daterangepicker.js",
              "assets/js/bootstrap-datetimepicker.min.js",
              "assets/js/circle-progress.min.js",
              "assets/js/script.js"
            ];
        
            let isCancelled = false;
        
            const loadScriptsSequentially = async () => {
              for (const url of scriptUrls) {
                if (isCancelled) break;
        
                await new Promise((resolve, reject) => {
                  const script = document.createElement('script');
                  script.src = url;
                  script.async = false;
                  script.onload = () => {
                    console.log(`Loaded: ${url}`);
                    resolve();
                  };
                  script.onerror = () => {
                    console.error(`Failed to load: ${url}`);
                    reject();
                  };
                  document.body.appendChild(script);
                });
              }
        
              // Now init plugins after scripts are loaded
              if (!isCancelled) {
                // if (window.AOS) {
                //   window.AOS.init();
                // }
        
                if (window.$ && typeof window.$.fn.datetimepicker === 'function') {
                  window.$('.datetimepicker').datetimepicker();
                }
        
                if (typeof window.initBackToTop === 'function') {
                  window.initBackToTop(); // assuming your backToTop script defines this
                }
        
                console.log('All scripts loaded and initialized.');
              }
            };
            loadScriptsSequentially();
            return () => {
              isCancelled = true;
            };
          }, []);

// 1. Add state for dateRangeReports (after other states):
const [dateRangeReports, setDateRangeReports] = useState(""); // Empty initially
const [dateRangeInvoice,setDateRangeInvoice] = useState("");

// 2. Add useEffect to initialize daterangepicker for reports (inside the main useEffect after loadScriptsSequentially, or in a separate useEffect):
useEffect(() => {
  setTimeout(() => {
    const $ = window.jQuery;

    if ($ && $('#bookingrange1').length > 0) {
      $('#bookingrange1')
        .off('apply.daterangepicker') // ✅ avoid duplicate binding
        .on('apply.daterangepicker', function (ev, picker) {
          const newRange =
            picker.startDate.format('MM/DD/YYYY') +
            ' - ' +
            picker.endDate.format('MM/DD/YYYY');

          console.log('Reports Date Range:', newRange);

          setDateRangeReports(newRange);
          setReportsCurrentPage(0);
        });
    }
  }, 1000); // ⏱ allow script.js to init picker
}, []);

useEffect(() => {
  setTimeout(() => {
    const $ = window.jQuery;

    if ($ && $('#bookingrange2').length > 0) {
      $('#bookingrange2')
        .off('apply.daterangepicker') // ✅ avoid duplicate binding
        .on('apply.daterangepicker', function (ev, picker) {
          const newRange =
            picker.startDate.format('MM/DD/YYYY') +
            ' - ' +
            picker.endDate.format('MM/DD/YYYY');

          console.log('Reports Date Range:', newRange);

          setDateRangeInvoice(newRange);
          setInvoiceCurrentPage(0);
        });
    }
  }, 1000); // ⏱ allow script.js to init picker
}, []);
 // Run once

// 3. Update the getDateRange to use dateRangeReports if set, else default:
const getDateRange = (type) => {
  const today = new Date();
  
  // Helper to pad with leading zeros (MM/DD/YYYY)
  const padDate = (date) => {
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  let fromDate, toDate;

  if (type === 'upcoming') {
    fromDate = padDate(today); // Today
    const upcomingEnd = new Date(today);
    upcomingEnd.setDate(today.getDate() + 7); // Next 7 days including today
    toDate = padDate(upcomingEnd);
  } else if (type === 'past') {
    const pastStart = new Date(today);
    pastStart.setDate(today.getDate() - 30); // Last 30 days
    fromDate = padDate(pastStart);
    toDate = padDate(today); // Today
  } else { // 'reports' or 'all' default to last 30 days
    const defaultStart = new Date(today);
    defaultStart.setDate(today.getDate() - 30); // Last 30 days
    fromDate = padDate(defaultStart);
    toDate = padDate(today); // Today
  }

  return { fromDate, toDate };
};
// 2. Add state for paging in reports section (after patientId and type):
const [reportsCurrentPage, setReportsCurrentPage] = useState(0);
const [reportsPageSize, setReportsPageSize] = useState(10);
const reportsPageSizeOptions = [5, 10, 50, 100, 500, "all"];

const [invoiceCurrentPage, setInvoiceCurrentPage] = useState(0);
const [invoicePageSize, setInvoicePageSize] = useState(10);
const invoicePageSizeOptions = [5, 10, 50, 100, 500, "all"];
// Query for Upcoming (Pending)
const { data: upcomingData, isLoading: isLoadingUpcoming } = useQuery({
  queryKey: ['upcomingAppointments',selectedDate],
  queryFn: async () => {
    let fromDate, toDate;
    if(selectedDate){
      const sel = new Date(selectedDate);
    const month = (sel.getMonth() + 1).toString().padStart(2, '0');
    const day = sel.getDate().toString().padStart(2, '0');
    const year = sel.getFullYear();
    fromDate = `${month}/${day}/${year}`;
    toDate = fromDate;   // same day
    }else{
       const range = getDateRange('upcoming');
      fromDate = range.fromDate;
      toDate = range.toDate;
    }
    const response = await AppointmentListService.fetchAppointmentsByDateForPending(fromDate, toDate, patientId, type, 0, 5); // Limit to 5
    return response;
  },
});
const upcomingAppointments = useMemo(
  () => upcomingData?.data?.data?.flat() ?? [],
  [upcomingData]
);
// Query for Past (Seen/Completed) - Using Seen for past
const { data: pastData, isLoading: isLoadingPast } = useQuery({
  queryKey: ['pastAppointments'],
  queryFn: async () => {
    const { fromDate, toDate } = getDateRange('past');
    const response = await AppointmentListService.fetchAppointmentsByDateForSeen(fromDate, toDate, patientId, type, 0, 5); // Limit to 5
    return response;
  },
});
const pastAppointments = useMemo(
  () => pastData?.data?.data?.flat() ?? [],
  [pastData]
);

// Query for Patients that created by user.
const { data: patientData, isLoading: isLoadingPatient } = useQuery({
  queryKey: ['patientDataReports'],
  queryFn: async () => {
    const response = await AppointmentListService.getPatientByCreatedById(patientId); // Limit to 5
    return response;
  },
});
const patientDataReports = useMemo(
  () => patientData?.data?.data?.flat() ?? [],
  [patientData]
);
// 4. Update reports query to use 'reports' type:
const { data: reportsData, isLoading: isLoadingReports } = useQuery({
  queryKey: ['reportsAppointments', reportsCurrentPage, reportsPageSize, dateRangeReports],
  queryFn: async () => {
    const [fromDate, toDate] = dateRangeReports
    ? dateRangeReports.split(' - ')
    : [
        moment().subtract(60, 'days').format('MM/DD/YYYY'),
        moment().add(60, 'days').format('MM/DD/YYYY')
      ];
    const size = reportsPageSize === "all" ? 99999 : reportsPageSize;
    const response = await AppointmentListService.fetchAppointmentsByDateForAll(fromDate, toDate, patientId, type, reportsCurrentPage, size);
    return response;
  },
  enabled: !!dateRangeReports || true, // Fetch even if no range (use default)
});
// reports for the Invoices
const { data: invoiceData, isLoading: isLoadingInvoice } = useQuery({
  queryKey: ['reportsInvoices', invoiceCurrentPage, invoicePageSize, dateRangeInvoice],
  queryFn: async () => {
    const [fromDate, toDate] = dateRangeInvoice
    ? dateRangeInvoice.split(' - ')
    : [
        moment().subtract(60, 'days').format('MM/DD/YYYY'),
        moment().add(60, 'days').format('MM/DD/YYYY')
      ];
    const size = invoicePageSize === "all" ? 99999 : invoicePageSize;
    const response = await AppointmentListService.getInvoiceByDate(fromDate, toDate, patientId, invoiceCurrentPage, size);
    return response;
  },
  enabled: !!dateRangeInvoice || true, // Fetch even if no range (use default)
});
// In the query, extract:
const reportsAppointments = reportsData?.data?.data?.[0] ?? [];
const reportsTotalPages = reportsData?.data?.totalPages ?? 0;
// eslint-disable-next-line no-unused-vars
const reportsTotalElements = reportsData?.data?.totalElements ?? 0;

const invoiceAppointments = invoiceData?.data?.data?.[0] ?? [];
const invoiceTotalPages = invoiceData?.data?.totalPages ?? 0;
// eslint-disable-next-line no-unused-vars
const invoiceTotalElements = invoiceData?.data?.totalElements ?? 0;
const handlePrint=(e,id)=>{
    e.preventDefault();
    handlePrintPrescription(id);
  }
// Add handlers (like in Appointment.js):



const handleReportsPageChange = (newPage) => {
  if (newPage >= 0 && newPage < reportsTotalPages) {
    setReportsCurrentPage(newPage);
  }
};

const handleReportsPageSizeChange = (e) => {
  setReportsPageSize(e.target.value);
  setReportsCurrentPage(0);
};

const handleInvoicePageChange = (newPage) => {
  if (newPage >= 0 && newPage < invoiceTotalPages) {
    setInvoiceCurrentPage(newPage);
  }
};

const handleInvoicePageSizeChange = (e) => {
  setInvoicePageSize(e.target.value);
  setInvoiceCurrentPage(0);
};

const handleShow = (e, inv) => {
    e.preventDefault();
    handlePrintInvoice({
      receiptNo: inv?.invoiceNumber,
      patientId: inv?.patientNumber,
      patientName: inv?.patientName,
      reportingDate: inv?.reportingDate,
      reportingTime: inv?.reportingTime,
      age: inv?.patientAge || "",
      gender: inv?.patientGender || "",
      emailId: inv?.patientEmail,
      mobileNo: inv?.patientMobile,
      address: inv?.patientAddress || "",
      testRows: inv?.testRows || [],
      discount: inv?.discount?.toFixed(2) || "0.00",
      paidAmount: inv?.paidAmount?.toFixed(2) || "0.00",
      dues: inv?.dues?.toFixed(2) || "0.00",
      totalAmount: inv?.totalAmount?.toFixed(2) || "0.00",
      companyHeaderImage: inv?.companyHeaderImg || '',
      companyFooterImage: 'nothing',
      invType:inv?.invType
    });
  };
   return(
    <>
    <style>
        {`
.dashboard-card-body {
    overflow: hidden;
  }
  
  .appointment-dash-list,
  .upcoming-appointment-slider {
    max-height: 320px;           /* adjust if needed */
    overflow-y: auto;
  }

  /* Clean up the <li> you are using in Past Swiper */
  .upcoming-appointment-slider .swiper-slide li {
    list-style: none;
    margin-bottom: 15px;
  }
    /* Dependents ko tight aur clean karne ke liye */
  .dependents-swiper {
    height: 220px !important;
    overflow: hidden;
  }

  .dependents-swiper .swiper-slide {
    height: 100% !important;
  }

  /* General card body tight rakho */
  .dashboard-card-body {
    max-height:220px;
    padding: 20px 15px;
  }

    `}</style>
   
     <div className="col-lg-8 col-xl-9">
        <div className="dashboard-header">
          <h3>Dashboard</h3>
          						
        </div>
        <div className="row">
        
          <div className="col-xl-12 d-flex">
            <div className="favourites-dashboard w-100">
              <div className="book-appointment-head">
                <h3><span>Book a new</span>Appointment</h3>
                <span className="add-icon"><a href="/search-doctors"><i className="fa-solid fa-circle-plus" /></a></span>
              </div>
             
            </div>								
          </div>
        </div>
        
        
        <div className="row">
          {/* Upcoming Appointments */}
          <div className="col-xl-5 d-flex flex-column">
            <div className="dashboard-card flex-fill">
      <div className="dashboard-card-head">
        <div className="header-title">
          <h5>Appointment</h5>
        </div>
        <div className="card-view-link">
          <div className="owl-nav slide-nav text-end nav-control" />
        </div>
      </div>
      <div className="dashboard-card-body" style={{maxHeight:"none"}}>
        <div className="apponiment-dates">
          <div
  className="d-flex overflow-auto pb-2"
  style={{
    gap: "10px",
    whiteSpace: "nowrap",
    scrollbarWidth: "none"
  }}
>
  {calendarDates.map((dateObj, idx) => {
    const isSelected =
      selectedDate === dateObj.fullDate.toDateString();

    const isToday =
      todayDate.toDateString() === dateObj.fullDate.toDateString();

    return (
      <div
        key={idx}
        onClick={() => {
          setSelectedDate(dateObj.fullDate.toDateString());
          console.log(dateObj.fullDate.toDateString());
        }}
        className={`text-center p-2 rounded-3 border ${
          isSelected
            ? "bg-primary text-white"
            : isToday
            ? "bg-light border-primary"
            : "bg-light"
        }`}
        style={{
          minWidth: "70px",
          cursor: "pointer"
        }}
      >
        <div style={{ fontSize: "12px" }}>
          {dateObj.day.toUpperCase()}
        </div>

        <div className="fw-bold">
          {dateObj.date}
        </div>

        <div style={{ fontSize: "10px" }}>
          {dateObj.fullDate.toLocaleDateString("en-US", {
            month: "short"
          })}
        </div>
      </div>
    );
  })}
</div>
          
{isLoadingUpcoming ? (<div>Loading ...</div>):
         (upcomingAppointments.length>0) ?
          (<div className="appointment-dash-list upcoming-appointment-slider">
            {upcomingAppointments
              .filter((appt) => {
  const apptDate = new Date(appt.appointmentDate);
  const selDate = new Date(selectedDate);

  return (
    apptDate.getFullYear() === selDate.getFullYear() &&
    apptDate.getMonth() === selDate.getMonth() &&
    apptDate.getDate() === selDate.getDate()
  );
})
              .map((appt) => (
                <div className="appointment-dash-card" key={appt.appointmentId}>
                  <div className="doctor-fav-list">
                    <div className="doctor-info-profile">
                      <a href="/" role="button" onClick={(e)=>{e.preventDefault()}} className="table-avatar">
                        <img
                          src={`${serverConfig.BASE_URL}/uploads/${appt.userImage}`}
                          alt={"Doctor"}
                          onError={(e) => {
    e.target.onerror = null; // prevents infinite loop
    e.target.src = "assets/img/doctor.png";
  }}
                        />
                      </a>
                      <div className="doctor-name-info">
                        <h5>
                          <a href="/" role="button" onClick={(e)=>{e.preventDefault()}}>{appt.userName}</a>
                        </h5>
                        <span className="fs-12 fw-medium">
                          {appt.specialities}
                        </span><br/>
                        <span className="fs-12 fw-medium">
                          Patient-{appt.patientName}
                        </span>
                      </div>
                    </div>
                    <a href="/" role="button" onClick={(e)=>{e.preventDefault()}} className="cal-plus-icon">
                      <i className="isax isax-hospital5" />
                    </a>
                  </div>
                  <div className="date-time">
                    <p>
                      <i className="isax isax-clock5" />{" "}
                      {new Date(appt.appointmentDate).toLocaleDateString("en-GB")} -{" "}
                      {appt.appointmentTime}
                    </p>
                  </div>
                </div>
              ))}
          </div>):(<div>No Appointments found</div>)}
        </div>
      </div>
    </div>


            {/* <div className="dashboard-card flex-fill">
              <div className="dashboard-card-head">
                <div className="header-title">
                  <h5>Notifications</h5>
                </div>
                <div className="card-view-link">
                  <a href="/" role="button" onClick={(e)=>{e.preventDefault()}}>View All</a>
                </div>
              </div>
              <div className="dashboard-card-body">
                <div className="table-responsive">
                  <table className="table dashboard-table">
                    <tbody>
                      <tr>
                        <td>
                          <div className="table-noti-info">
                            <div className="table-noti-icon color-violet">
                              <i className="fa-solid fa-bell" />
                            </div>
                            <div className="table-noti-message">
                              <h6><a href="/" role="button" onClick={(e)=>{e.preventDefault()}}>Booking Confirmed on <span> 21 Mar 2024 </span> 10:30 AM</a></h6>
                              <span className="message-time">Just Now</span>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div className="table-noti-info">
                            <div className="table-noti-icon color-blue">
                              <i className="fa-solid fa-star" />
                            </div>
                            <div className="table-noti-message">
                              <h6><a href="/" role="button" onClick={(e)=>{e.preventDefault()}}>You have a  <span> New </span> Review for your Appointment </a></h6>
                              <span className="message-time">5 Days ago</span>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div className="table-noti-info">
                            <div className="table-noti-icon color-red">
                              <i className="isax isax-calendar-tick5" />
                            </div>
                            <div className="table-noti-message">
                              <h6><a href="/" role="button" onClick={(e)=>{e.preventDefault()}}>You have Appointment with <span> Ahmed </span> by 01:20 PM </a></h6>
                              <span className="message-time">12:55 PM</span>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div className="table-noti-info">
                            <div className="table-noti-icon color-yellow">
                              <i className="fa-solid fa-money-bill-1-wave" />
                            </div>
                            <div className="table-noti-message">
                              <h6><a href="/" role="button" onClick={(e)=>{e.preventDefault()}}>Sent an amount of <span> $200 </span> for an Appointment  by 01:20 PM </a></h6>
                              <span className="message-time">2 Days ago</span>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div className="table-noti-info">
                            <div className="table-noti-icon color-blue">
                              <i className="fa-solid fa-star" />
                            </div>
                            <div className="table-noti-message">
                              <h6><a href="/" role="button" onClick={(e)=>{e.preventDefault()}}>You have a  <span> New </span> Review for your Appointment </a></h6>
                              <span className="message-time">5 Days ago</span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div> */}
          </div>
         
          <div className="col-xl-7 d-flex flex-column">
             {/* Past Appointments */}
            <div className="dashboard-card flex-fill">
              <div className="dashboard-card-head">
                <div className="header-title">
                  <h5>Past Appointments</h5>
                </div>
                <div className="card-view-link">
                  <div className="owl-nav slide-nav2 text-end nav-control" />
                </div>
              </div>
              <div className="dashboard-card-body" style={{overflow:"auto"}}>
  {isLoadingPast ? (
    <div className="text-center">Loading...</div>
  ) : pastAppointments.length > 0 ? (
    <Swiper
  modules={[Navigation, Grid]}
  navigation
  spaceBetween={20}
  slidesPerView={1}        // 👈 ONE card per row
  slidesPerGroup={1}       // 👈 NEXT moves TWO cards
  grid={{
    rows: 2,
    fill: "row",           // VERY IMPORTANT
  }}
  style={{ maxHeight: "380px", overflow: "hidden" }}
  breakpoints={{
  0: {
    slidesPerView: 1,
    grid: { rows: 1 },
    slidesPerGroup: 1,
  },
  768: {
    slidesPerView: 1,
    grid: { rows: 2 },   // ✅ stacked full-width
    slidesPerGroup: 1,  // ✅ FIX
  },
}}
  className="upcoming-appointment-slider"
>
  {pastAppointments.map((apt) => (
    <SwiperSlide key={apt.appointmentId}>
      <li>
        <div className="doctor-fav-list">
          <div className="doctor-info-profile">
            <a href="/" role="button" onClick={(e)=>{e.preventDefault()}} className="table-avatar">
              <img
                src={`${serverConfig.BASE_URL}/uploads/${apt.userImage}`}
                alt="Doctor"
                onError={(e) => {
    e.target.onerror = null; // prevents infinite loop
    e.target.src = "assets/img/doctor.png";
  }}
              />
            </a>

            <div className="doctor-name-info">
              <h5>
                <a href="/" role="button" onClick={(e)=>{e.preventDefault()}}>{apt.userName}</a>
              </h5>
              <span className="fs-12 fw-medium">{apt.specialities}</span>
            </div>

            <div className="doctor-name-info" style={{ marginLeft: "10px" }}>
              <h5>
                <a href="/" role="button" onClick={(e)=>{e.preventDefault()}}>Patient-{apt.patientName}</a>
              </h5>
              <span className="fs-12 fw-medium">
                {apt?.age ?? "--"}
              </span>
            </div>
          </div>

          <a href="/" role="button" onClick={(e)=>{e.preventDefault()}} className="cal-plus-icon">
            <i className="isax isax-hospital5" />
          </a>
        </div>

        <div className="date-time">
          <p>
            <i className="isax isax-clock5" />
            {new Date(apt.appointmentDate)
              .toLocaleDateString("en-GB")
              .replaceAll("/", "-")}{" "}
            - {apt.appointmentTime}
          </p>
        </div>

        <div className="card-btns gap-3">
          <button
            className="btn btn-md btn-light rounded-pill"
            onClick={(e) => handlePrint(e, apt.appointmentId)}
          >
            <i className="isax isax-messages-25" />
            View
          </button>

          <a
            href="/search-doctors"
            style={{ marginLeft: "10px" }}
            className="btn btn-md btn-primary-gradient rounded-pill"
          >
            <i className="isax isax-calendar-tick5" />
            Book Again
          </a>
        </div>
      </li>
    </SwiperSlide>
  ))}
</Swiper>
  ) : (
    <div className="text-center">No past appointments.</div>
  )}
</div>
            </div>
            {/* Dependents */}
            <div className="dashboard-card flex-fill">
              <div className="dashboard-card-head">
                <div className="header-title">
                  <h5>Dependant</h5>
                </div>
                {/* <div className="card-view-link">
                 
                  <a href="/">View All</a>
                </div> */}
              </div>
              <div className="dashboard-card-body">
  {isLoadingPatient ? (
    <div>Loading...</div>
  ) : patientDataReports.length > 0 ? (
    <Swiper
      direction="vertical"
      slidesPerView={1}
      spaceBetween={0}
      modules={[Mousewheel]}
      mousewheel
      style={{ maxHeight: "100px" }}
      className="upcoming-appointment-slider"
    >
      {patientDataReports.map((p) => (
        <SwiperSlide key={p.patientId}>
          <div className="doctor-fav-list">
            <div className="doctor-info-profile">
              <a href="/" role="button" onClick={(e)=>{e.preventDefault()}} className="table-avatar">
                <img
                  src="assets/img/patient.png"
                  alt={p.patientName}
                  onError={(e) => {
    e.target.onerror = null; // prevents infinite loop
    e.target.src = "assets/img/patient.png";;
  }}
                />
              </a>

              <div className="doctor-name-info">
                <h5>
                  <a href="/" role="button" onClick={(e)=>{e.preventDefault()}}>{p.patientName}</a>
                </h5>
                <span>
                  {p.gender} - {p.age}
                </span>
              </div>
            </div>
            <div className="d-flex align-items-center">
              <Link
  to="/patient-profile"
  state={{ patientId: p.patientId }}   // pass PatientDTO
  className="cal-plus-icon"
>
  <i className="isax isax-eye4" />
</Link>
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  ) : (
    <div>No patients found</div>
  )}
</div>

            </div>									
          </div>
        </div>
        {/* Reports */}
        <div className="row">
          <div className="col-xl-12 d-flex">
            <div className="dashboard-card w-100">
              <div className="dashboard-card-head">
                <div className="header-title">
                  <h5>Reports</h5>
                </div>											
              </div>
              <div className="dashboard-card-body"  style={{maxHeight:"none"}}>
                <div className="account-detail-table">
                  {/* Tab Menu */}
                  <nav className="patient-dash-tab border-0 pb-0">
                    <ul className="nav nav-tabs-bottom">
                      <li className="nav-item">
                        <a className="nav-link active" href="#appoint-tab" data-bs-toggle="tab">Appointments</a>
                      </li>
                      
                      <li className="nav-item">
                        <a className="nav-link" href="#invoice-tab" data-bs-toggle="tab">Invoices</a>
                      </li>
                    </ul>
                  </nav>
                  {/* /Tab Menu */}
                  {/* Tab Content */}
                  <div className="tab-content pt-0">
                    {/* Appointments Tab */}
                    <div id="appoint-tab" className="tab-pane fade show active">
                      <div className="custom-new-table">
                        <div className="d-flex align-items-center justify-content-end mb-3">
                          {reportsAppointments.length > 0 && (
                            <div className="me-3" style={{ marginBottom: '20px' }}>
                              <select className="form-select" style={{ height: '36px', minHeight: '36px', fontSize: '14px', paddingTop: '4px', paddingBottom: '4px', paddingLeft: '10px' }} value={reportsPageSize} onChange={handleReportsPageSizeChange}>
                                {reportsPageSizeOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                              </select>
                            </div>
                          )}
                          <div className="position-relative daterange-wraper">
                            <div className="input-groupicon calender-input">
                              <input type="text" id="bookingrange1" className="form-control date-range bookingrange"
                               placeholder="From Date - To Date "
                                value={dateRangeReports || 'Select Date Range'}
                                readOnly/>
                            </div>
                            <i className="isax isax-calendar-1" />
                          </div>
                        </div>
                       
                        <div className="table-responsive">
                          <table className="table table-hover table-center mb-0">
                            <thead>
                              <tr>
                                <th>ID</th>
                                <th>Doctor</th>
                                <th>Patient</th>
                                <th>Date</th>
                                <th>Type</th>
                                <th>Status</th>
                                <th>view</th>
                              </tr>
                            </thead>
                            {/* // 4. Replace the entire <tbody> in the "Reports" section (keeps design, maps appointment fields to table columns): */}
<tbody>
  {isLoadingReports ? (
    <tr><td colSpan="6" className="text-center">Loading...</td></tr>
  ) : reportsAppointments.length > 0 ? (
    reportsAppointments.map((apt) => (
      <tr key={apt.appointmentId}>
        <td>
                                  <a href="/" role="button" onClick={(e)=>{e.preventDefault()}}><span className="link-primary">#{apt.tokenId}</span></a>
                                </td>
       <td>
                                  <h2 className="table-avatar">
                                    <a href="/" className="avatar avatar-sm me-2">
                                      <img className="avatar-img rounded-3"
                                       src={`${serverConfig.BASE_URL}/uploads/${apt.userImage}`}
                                       onError={(e) => {
    e.target.onerror = null; // prevents infinite loop
    e.target.src = "assets/img/doctor.png";;
  }}
                                       alt="User " />
                                    </a>
                                    <a href="/">{apt.userName}</a>
                                  </h2>
                                </td>
                                <td>
                                  <Link
  to="/patient-profile"
  state={{ patientId: apt.patientId }}   // pass PatientDTO
  className="cal-plus-icon"
>
  {apt.patientName}
</Link></td>
                                <td>
                                  {new Date(apt.appointmentDate).toLocaleDateString('en-GB').replaceAll('/', '-')}
                                  {new Date(apt.updatedAt).toLocaleDateString('en-GB').replaceAll('/', '-')}
                                </td>
                                <td>{apt.appointmentType}</td>
                                <td>
                                  <span className="badge badge-xs p-2 badge-soft-purple inline-flex align-items-center">
                                    <i className="fa-solid fa-circle me-1 fs-5"/>{apt.status}</span>
                                </td>
        <td>
          <div className="action-item">
            <button 
             style={{border:'none',backgroundColor:'transparent'}}
              disabled={apt.status !== "COMPLETED"}
              onClick={(e)=>handlePrint(e,apt.appointmentId)}>
              <i className="isax isax-eye" />
            </button>
            
          </div>
        </td>
      </tr>
    ))
  ) : (
    <tr><td colSpan="6" className="text-center">No appointments found.</td></tr>
  )}
</tbody>
                          </table>
                          {/* // 5. Add paging below the table (inside the same div as the table, after </table>): */}
{reportsTotalPages > 1 && reportsPageSize !== "all" && (
  <div className="pagination dashboard-pagination">
    <ul>
      <li>
        <a href="/" role="button" className="page-link prev-link" onClick={(e) =>{e.preventDefault(); handleReportsPageChange(reportsCurrentPage - 1)}} disabled={reportsCurrentPage === 0}><i className="fa-solid fa-chevron-left me-2" />Prev</a>
      </li>
      {[...Array(reportsTotalPages).keys()].map((page) => (
        <li key={page}>
          <a href="/" role="button"className={`page-link ${reportsCurrentPage === page ? 'active' : ''}`} onClick={(e) =>{e.preventDefault(); handleReportsPageChange(page)}}>{page + 1}</a>
        </li>
      ))}
      <li>
        <a href="/" role="button" className="page-link next-link" onClick={(e) =>{ e.preventDefault();handleReportsPageChange(reportsCurrentPage + 1)}} disabled={reportsCurrentPage === reportsTotalPages - 1}>Next<i className="fa-solid fa-chevron-right ms-2" /></a>
      </li>
    </ul>
  </div>
)}
                        </div>
                      </div>
                    </div>
                    {/* /Appointments Tab */}
                    
                  
                    {/*Invoices Tab */}
                    <div className="tab-pane fade" id="invoice-tab">
                      <div className="custom-table">
                         <div className="d-flex align-items-center justify-content-end mb-3">
                           {invoiceAppointments.length > 0 && (
                             <div className="me-3" style={{ marginBottom: '20px' }}>
                               <select className="form-select" style={{ height: '36px', minHeight: '36px', fontSize: '14px', paddingTop: '4px', paddingBottom: '4px', paddingLeft: '10px' }} value={invoicePageSize} onChange={handleInvoicePageSizeChange}>
                                 {invoicePageSizeOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                               </select>
                             </div>
                           )}
                           <div className="position-relative daterange-wraper">
                             <div className="input-groupicon calender-input">
                               <input type="text" id="bookingrange2" className="form-control date-range bookingrange"
                                placeholder="From Date - To Date "
                                 value={dateRangeInvoice || 'Select Date Range'}
                                 readOnly/>
                             </div>
                             <i className="isax isax-calendar-1" />
                           </div>
                         </div>
                        <div className="table-responsive">
                          <table className="table table-center mb-0">
                            <thead>
                              <tr>
                                <th>ID</th>
                                <th>Doctor</th>
                                <th>Patient</th>
                                <th>Booked on</th>
                                <th>Amount</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
  {isLoadingInvoice ? (
    <tr>
      <td colSpan="6" className="text-center">Loading...</td>
    </tr>
  ) : invoiceAppointments.length > 0 ? (
    invoiceAppointments.map((inv) => (
      <tr key={inv.invoiceId}>
        {/* Invoice Number */}
        <td>
          <a href="/" role="button" onClick={(e)=>{e.preventDefault()}} className="link-primary">
            #{inv.invoiceNumber}
          </a>
        </td>

        {/* Doctor */}
        <td>
          <h2 className="table-avatar">
            <a href="/" role="button" onClick={(e)=>{e.preventDefault()}} className="avatar avatar-sm me-2">
              <img
                className="avatar-img rounded-3"
                src={`assets/img/doctor.png`}
                alt="Doctor"
                onError={(e) => {
                e.target.onerror = null; // prevents infinite loop
                e.target.src = "assets/img/doctor.png";
             }}
              />
            </a>
            <a href="/" role="button" onClick={(e)=>{e.preventDefault()}}>{inv.comanyName}</a>
          </h2>
        </td>

        <td>{inv.patientName}</td>

        {/* Booked On */}
        <td>
          {new Date(inv.reportingDate)
            .toLocaleDateString("en-GB")
            .replaceAll("/", "-")}
        </td>

        {/* Amount */}
        <td>₹{inv.totalAmount}</td>

        {/* Action */}
        <td>
          <div className="action-item">
            <button
              style={{ border: "none", background: "transparent" }}
              onClick={(e) => handleShow(e, inv)}
            >
              <i className="isax isax-eye4" />
            </button>
          </div>
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="6" className="text-center">
        No invoices found
      </td>
    </tr>
  )}
</tbody>

                          </table>
                          {invoiceTotalPages > 1 && invoicePageSize !== "all" && (
  <div className="pagination dashboard-pagination">
    <ul>
      <li>
        <a href="/" role="button" className="page-link prev-link" onClick={(e) =>{e.preventDefault(); handleInvoicePageChange(invoiceCurrentPage - 1)}} disabled={invoiceCurrentPage === 0}><i className="fa-solid fa-chevron-left me-2" />Prev</a>
      </li>
      {[...Array(invoiceTotalPages).keys()].map((page) => (
        <li key={page}>
          <a href="/" role="button" className={`page-link ${invoiceCurrentPage === page ? 'active' : ''}`} onClick={(e) => {e.preventDefault();handleInvoicePageChange(page)}}>{page + 1}</a>
        </li>
      ))}
      <li>
        <a href="/" role="button" className="page-link next-link" onClick={(e) =>{e.preventDefault(); handleInvoicePageChange(invoiceCurrentPage + 1)}} disabled={invoiceCurrentPage === invoiceTotalPages - 1}>Next<i className="fa-solid fa-chevron-right ms-2" /></a>
      </li>
    </ul>
  </div>
)}

                        </div>
                      </div>
                    </div>
                    {/* Invoices Tab */}
                  </div>
                  {/* Tab Content */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
       </>
   );
}
export default Dashboard;